import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';

const routes: Routes = [
    {
        path: '',
        component: AppComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./modules/sign-in/sign-in.module').then(
                        (m) => m.SignInModule
                    ),
            },
            {
                path: 'catalog',
                loadChildren: () =>
                    import('./modules/catalog/catalog.module').then(
                        (m) => m.CatalogModule
                    ),
            },
            {
                path: 'participant',
                loadChildren: () =>
                    import('./modules/participant/participant.module').then(
                        (m) => m.ParticipantModule
                    ),
            },
            {
                path: 'administrator',
                loadChildren: () =>
                    import(
                        './modules/administrator/application/administrator.module'
                    ).then((m) => m.AdministratorModule),
            },
            {
                path: 'commercial-manager',
                loadChildren: () =>
                    import(
                        './modules/commercial-manager/commercial-manager.module'
                    ).then((m) => m.CommercialManagerModule),
            },
            {
                path: 'credit-specialist',
                loadChildren: () =>
                    import(
                        './modules/credit-specialist/credit-specialist.module'
                    ).then((m) => m.CreditSpecialistModule),
            },
            {
                path: 'terms-and-conditions',
                loadChildren: () =>
                    import(
                        './modules/terms-and-conditions/terms-and-conditions.module'
                    ).then((m) => m.TermsAndConditionsModule),
            },
            {
                path: 'error',
                loadChildren: () =>
                    import('./modules/error/error.module').then(
                        (m) => m.ErrorModule
                    ),
            },
        ],
    },
    { path: '**', redirectTo: 'error/404', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
